<template>
  <v-dialog v-model="isShowForm" persistent max-width="400px">
    <v-card :class="classContents">
      <v-card-title>
        <h3>{{ dscList.name }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon x-small @click="resestList()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="meta-form-pd">
        <p>{{ this.$t('meta.reason.q') }}</p>
      </v-card-text>
      <v-card-text class="meta-form-pd">
        <v-textarea v-model="reason" auto-grow outlined :hide-details="true" class="full-width-textarea"></v-textarea>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn :disabled="!reason" :loading="loading" small color="primary" @click="save()">{{ $t('common.save') }}</v-btn>
        <v-btn small color="primary" @click="resestList()">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
      <v-dialog v-model="confirmDialog" max-width="300px">
        <v-card>
          <v-card-title>{{ $t('common.info') }}</v-card-title>
          <v-card-text class="meta-form-pd">
            <span v-html="$t('common.successful')"></span>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn small @click="closeList()">{{ this.$t('common.confirm') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'MetaForm',
  props: {
    dscList: Object,
    systemId: String,
  },
  data() {
    return {
      isShowForm: false,
      loading: false,
      reason: '',
      confirmDialog: false,
      from: 'meta',
    };
  },
  computed: {
    ...mapState('preference/meta/', ['addSuccess']),
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  watch: {
    addSuccess() {
      // BEGIN::Modified.by.KWShin.2022.09.19.
      // 값이 'success'일 때만 동작을 하면 된다.
      if (this.addSuccess == 'success') {
        this.loading = false;
        this.openConfirmDialog();
      }
      // FINISH::Modified.by.KWShin.2022.09.19.
    },
  },
  methods: {
    openConfirmDialog() {
      this.resestList();
      this.confirmDialog = true;
    },
    resestList() {
      this.isShowForm = false;
      this.reason = '';
    },
    closeList() {
      this.confirmDialog = false;
      this.$emit('openList');
    },
    // async save() {
    save() {
      this.loading = true;
      const params = {
        systemId: this.systemId,
        tableName: this.dscList.metaSap.tableName,
        reason: this.reason,
      };
      this.$store.dispatch('preference/meta/updateDescription', params);
    },
  },
};
</script>
